<div class="resubmit-champion-dialog">
  <!-- Close Button -->
  <button class="resubmit-champion-dialog__close-btn" (click)="onClose()" type="button" aria-label="Close">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="12" fill="#96080B"/>
      <path d="M16 8L8 16M8 8L16 16" stroke="white" stroke-width="2" stroke-linecap="round"/>
    </svg>
  </button>

  <!-- Close Button Mobile -->
  <button class="resubmit-champion-dialog__close-btn-mobile" (click)="onClose()" type="button" aria-label="Close">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="12" fill="#96080B"/>
      <path d="M16 8L8 16M8 8L16 16" stroke="white" stroke-width="2" stroke-linecap="round"/>
    </svg>
  </button>

  <div class="resubmit-champion-dialog__container">
    <form [formGroup]="form" class="resubmit-champion-dialog__form">
      <!-- Header -->
      <div class="resubmit-champion-dialog__header">
        <p class="resubmit-champion-dialog__header-text">{{ 'settings.my_championed.become_champion_header' | translateLang }}</p>
        <h2 class="resubmit-champion-dialog__org-name">{{ data.organizationName }}</h2>
      </div>

      <!-- Description -->
      <p class="resubmit-champion-dialog__description">
        {{ 'settings.my_championed.champion_description' | translateLang:{'organizationName': data.organizationName} }}
      </p>

      <!-- Visibility Notice -->
      <div class="resubmit-champion-dialog__notice">
        <p class="resubmit-champion-dialog__notice-text">
          {{ 'settings.my_championed.visibility_notice' | translateLang }}
        </p>
      </div>

      <!-- Form Fields -->
      <div class="resubmit-champion-dialog__fields">
        <!-- Desktop Layout -->
        <div class="resubmit-champion-dialog__fields-grid">
          <!-- Personal Name -->
          <div class="resubmit-champion-dialog__field">
            <label class="resubmit-champion-dialog__label">{{ 'settings.my_championed.personal_name_label' | translateLang }}</label>
            <input
              type="text"
              class="resubmit-champion-dialog__input"
              formControlName="championName"
              [placeholder]="'settings.my_championed.enter_name_placeholder' | translateLang"
            />
          </div>

          <!-- Engaged Since - Desktop -->
          <div class="resubmit-champion-dialog__field resubmit-champion-dialog__field--desktop">
            <label class="resubmit-champion-dialog__label">{{ 'settings.my_championed.engaged_since_label' | translateLang }}</label>
            @if (data.isEditMode) {
              <!-- Edit mode: Show dropdowns -->
              <div class="resubmit-champion-dialog__date-selects resubmit-champion-dialog__date-selects--desktop">
                <select class="resubmit-champion-dialog__select" formControlName="engagedMonth">
                  <option value="">{{ 'settings.my_championed.month_placeholder' | translateLang }}</option>
                  @for (month of months; track month) {
                    <option [value]="month">{{ month }}</option>
                  }
                </select>
                <select class="resubmit-champion-dialog__select" formControlName="engagedYear">
                  <option value="">{{ 'settings.my_championed.year_placeholder' | translateLang }}</option>
                  @for (year of years; track year) {
                    <option [value]="year">{{ year }}</option>
                  }
                </select>
              </div>
            } @else {
              <!-- Resubmit mode: Show readonly field -->
              <input
                type="text"
                class="resubmit-champion-dialog__input"
                [value]="form.value.engagedMonth + ' ' + form.value.engagedYear"
                readonly
                [placeholder]="'settings.my_championed.select_month_year_placeholder' | translateLang"
              />
            }
          </div>

          <!-- Media Upload -->
          <div class="resubmit-champion-dialog__field">
            <label class="resubmit-champion-dialog__label">{{ 'settings.my_championed.media_uploaded_label' | translateLang }}</label>
            <div class="resubmit-champion-dialog__file-input">
              <input
                type="file"
                id="fileUpload"
                accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx"
                (change)="onFileSelected($event)"
                [disabled]="!data.isEditMode || isUploading"
                style="display: none"
              />

              @if (!selectedFile) {
                <!-- No file selected - show upload button -->
                <label
                  for="fileUpload"
                  class="resubmit-champion-dialog__file-label"
                  [class.resubmit-champion-dialog__file-label--disabled]="!data.isEditMode"
                >
                  <span class="resubmit-champion-dialog__file-name">{{ mediaFileName || ('settings.my_championed.no_file_selected' | translateLang) }}</span>
                  @if (data.isEditMode) {
                    <button type="button" class="resubmit-champion-dialog__upload-btn">
                      <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.25 5.4375V0.4375M5.25 0.4375L3 2.6875M5.25 0.4375L7.5 2.6875M0.75 5.4375V6.6875C0.75 7.00652 0.876763 7.31223 1.10225 7.53775C1.32777 7.76324 1.63348 7.89001 1.9525 7.89001H8.5475C8.86652 7.89001 9.17223 7.76324 9.39775 7.53775C9.62324 7.31223 9.75 7.00652 9.75 6.6875V5.4375" stroke="#3A3A3A" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <span>{{ 'settings.my_championed.upload_button' | translateLang }}</span>
                    </button>
                  }
                </label>
              } @else {
                <!-- File selected - show file info and status -->
                <div class="resubmit-champion-dialog__file-preview">
                  <div class="resubmit-champion-dialog__file-info">
                    <span class="resubmit-champion-dialog__file-name">{{ mediaFileName }}</span>
                    @if (fileSize) {
                      <span class="resubmit-champion-dialog__file-size">{{ fileSize }}</span>
                    }
                  </div>
                  <div class="resubmit-champion-dialog__file-actions">
                    @if (isUploading) {
                      <span class="resubmit-champion-dialog__upload-status">{{ 'settings.my_championed.uploading_status' | translateLang }}</span>
                    } @else {
                      <span class="resubmit-champion-dialog__upload-status resubmit-champion-dialog__upload-status--success">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M11.6667 3.5L5.25 9.91667L2.33333 7" stroke="#00A63E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        {{ 'settings.my_championed.uploaded_status' | translateLang }}
                      </span>
                      @if (data.isEditMode) {
                        <button type="button" class="resubmit-champion-dialog__remove-btn" (click)="onRemoveFile()">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 4L4 12M4 4L12 12" stroke="#181818" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </button>
                      }
                    }
                  </div>
                </div>
              }
            </div>
          </div>

          <!-- Visibility Duration -->
          <div class="resubmit-champion-dialog__field">
            <label class="resubmit-champion-dialog__label">{{ 'settings.my_championed.visibility_duration_label' | translateLang }}</label>
            <select class="resubmit-champion-dialog__select" formControlName="visibilityDuration">
              @for (option of visibilityOptions; track option.value) {
                <option [value]="option.value">{{ option.label }}</option>
              }
            </select>
          </div>
        </div>

        <!-- Mobile Engaged Since -->
        <div class="resubmit-champion-dialog__field resubmit-champion-dialog__field--mobile">
          <label class="resubmit-champion-dialog__label">{{ 'settings.my_championed.engagement_duration_label' | translateLang }}</label>
          <div class="resubmit-champion-dialog__date-selects">
            <select class="resubmit-champion-dialog__select" formControlName="engagedMonth">
              <option value="">{{ 'settings.my_championed.month_placeholder' | translateLang }}</option>
              @for (month of months; track month) {
                <option [value]="month">{{ month }}</option>
              }
            </select>
            <select class="resubmit-champion-dialog__select" formControlName="engagedYear">
              <option value="">{{ 'settings.my_championed.year_placeholder' | translateLang }}</option>
              @for (year of years; track year) {
                <option [value]="year">{{ year }}</option>
              }
            </select>
          </div>
        </div>

        <!-- Testimonial -->
        <div class="resubmit-champion-dialog__testimonial-section">
          <label class="resubmit-champion-dialog__testimonial-label">{{ 'settings.my_championed.testimonial' | translateLang }}</label>

          <!-- Mobile Instructions -->
          <div class="resubmit-champion-dialog__testimonial-instructions">
            <p>{{ 'settings.my_championed.testimonial_instructions' | translateLang }}</p>
            <ol>
              <li>{{ 'settings.my_championed.testimonial_question_1' | translateLang }}</li>
              <li>{{ 'settings.my_championed.testimonial_question_2' | translateLang }}</li>
              <li>{{ 'settings.my_championed.testimonial_question_3' | translateLang }}</li>
            </ol>
          </div>

          <textarea
            class="resubmit-champion-dialog__textarea"
            formControlName="testimonial"
            rows="6"
            [placeholder]="'settings.my_championed.testimonial_placeholder' | translateLang"
          ></textarea>
        </div>

        <!-- Mobile Visibility Duration -->
        <div class="resubmit-champion-dialog__field resubmit-champion-dialog__field--mobile-visibility">
          <label class="resubmit-champion-dialog__label">
            {{ 'settings.my_championed.visibility_profile_question' | translateLang }}
            <span class="resubmit-champion-dialog__required">*</span>
          </label>
          <select class="resubmit-champion-dialog__select" formControlName="visibilityDuration">
            @for (option of visibilityOptions; track option.value) {
              <option [value]="option.value">{{ option.label }}</option>
            }
          </select>
        </div>

        <!-- Mobile Upload -->
        <div class="resubmit-champion-dialog__field resubmit-champion-dialog__field--mobile-upload">
          <label class="resubmit-champion-dialog__label">{{ 'settings.my_championed.media_upload_label' | translateLang }}</label>
          <div class="resubmit-champion-dialog__upload-box" [class.resubmit-champion-dialog__upload-box--disabled]="!data.isEditMode || isUploading">
            <input
              type="file"
              id="fileUploadMobile"
              accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx"
              (change)="onFileSelected($event)"
              [disabled]="!data.isEditMode || isUploading"
              style="display: none"
            />
            <label for="fileUploadMobile" class="resubmit-champion-dialog__upload-label" [class.resubmit-champion-dialog__upload-label--disabled]="!data.isEditMode || isUploading">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 15V3M12 3L8 7M12 3L16 7M3 15V18C3 19.1046 3.89543 20 5 20H19C20.1046 20 21 19.1046 21 18V15" stroke="#3A3A3A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span class="resubmit-champion-dialog__upload-text">{{ 'settings.my_championed.upload_media_text' | translateLang }}</span>
              <span class="resubmit-champion-dialog__upload-formats">{{ 'settings.my_championed.upload_formats_text' | translateLang }}</span>
            </label>
          </div>
          @if (selectedFile) {
            <div class="resubmit-champion-dialog__mobile-file-info">
              <div class="resubmit-champion-dialog__mobile-file-details">
                <p class="resubmit-champion-dialog__uploaded-file">{{ mediaFileName }}</p>
                @if (fileSize) {
                  <p class="resubmit-champion-dialog__uploaded-file-size">{{ fileSize }}</p>
                }
              </div>
              @if (isUploading) {
                <span class="resubmit-champion-dialog__mobile-upload-status">{{ 'settings.my_championed.uploading_status' | translateLang }}</span>
              } @else {
                <div class="resubmit-champion-dialog__mobile-file-actions">
                  <span class="resubmit-champion-dialog__mobile-upload-status resubmit-champion-dialog__mobile-upload-status--success">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11.6667 3.5L5.25 9.91667L2.33333 7" stroke="#00A63E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    {{ 'settings.my_championed.uploaded_status' | translateLang }}
                  </span>
                  @if (data.isEditMode) {
                    <button type="button" class="resubmit-champion-dialog__mobile-remove-btn" (click)="onRemoveFile()">
                      {{ 'settings.my_championed.remove_button' | translateLang }}
                    </button>
                  }
                </div>
              }
            </div>
          } @else if (mediaFileName) {
            <p class="resubmit-champion-dialog__uploaded-file">{{ 'settings.my_championed.uploaded_prefix' | translateLang }} {{ mediaFileName }}</p>
          }
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="resubmit-champion-dialog__actions">
        <!-- Desktop Button -->
        <button
          type="button"
          class="resubmit-champion-dialog__submit-btn resubmit-champion-dialog__submit-btn--desktop"
          (click)="onResubmit()"
          [disabled]="isSubmitting || (data.isEditMode && !form.valid)"
        >
          {{ isSubmitting ? ('settings.my_championed.submitting_status' | translateLang) : (data.isEditMode ? ('settings.my_championed.submit_button' | translateLang) : ('settings.my_championed.resubmit_button' | translateLang)) }}
        </button>

        <!-- Mobile Buttons -->
        @if (data.isEditMode) {
          <button
            type="button"
            class="resubmit-champion-dialog__draft-btn resubmit-champion-dialog__draft-btn--mobile"
            (click)="onSaveAsDraft()"
            [disabled]="isSubmitting"
          >
            {{ 'settings.my_championed.save_as_draft_button' | translateLang }}
          </button>
        }
        <button
          type="button"
          class="resubmit-champion-dialog__submit-btn resubmit-champion-dialog__submit-btn--mobile"
          [class.resubmit-champion-dialog__submit-btn--full]="!data.isEditMode"
          (click)="onResubmit()"
          [disabled]="isSubmitting || (data.isEditMode && !form.valid)"
        >
          {{ isSubmitting ? ('settings.my_championed.submitting_status' | translateLang) : (data.isEditMode ? ('settings.my_championed.submit_button' | translateLang) : ('settings.my_championed.resubmit_button' | translateLang)) }}
        </button>
      </div>
    </form>
  </div>
</div>
